module.exports = __webpack_public_path__ + "static/media/自动对联).01c94a03.png";